// As linhas de total da conta, na ordem que a configuração pedir.
import React from "react";
import { DadosDoPedido } from "../../../../store/Slices/orderSlice";
import * as Styles from "../../styles/PointOfSale.styles";

export const TabelaDeTotais: React.FC<{
  component: any;
  componentProps: any;
  orderDataZustand: DadosDoPedido;
}> = ({
  component,
  componentProps,
  orderDataZustand,
}) => {
  return (
    <Styles.TotalTable
      selected={Boolean(component.componentSelected)}
      id={String(component.componentId)}
      componentPosition={componentProps.componentPosition}
      componentBrightness={String(componentProps.componentBrightness)}
      componentWidth={String(componentProps.componentWidth)}
      componentHeight={String(componentProps.componentHeight)}
      componentStatus={String(componentProps.componentStatus)}
      componentBackgroundColor={String(
        componentProps.componentBackgroundColor
      )}
    >
      {component.componentSelected && (
        <Styles.SelectedIcon
          top={component.componentProps.componentPosition.y}
          left={component.componentProps.componentPosition.x}
        >
          zoom_out_map
        </Styles.SelectedIcon>
      )}
      <Styles.TotalTableHeader>
        <Styles.TotalTableHeaderRow>
          <Styles.TotalTableHeaderCell
            columnWidth="100%" // Largura total
          >
            Totais
          </Styles.TotalTableHeaderCell>
        </Styles.TotalTableHeaderRow>
      </Styles.TotalTableHeader>
      <Styles.TotalTableBody
        componentBackgroundColor={String(componentProps.componentBackgroundColor)}
      >
        {componentProps.componentRows.map((row: any) => {
          if (row.rowStatus && row.rowInfo === "total") {
            return (
              <Styles.TotalTableRow key={row.rowId} style={{ fontSize: "var(--fs-2xl)", fontWeight: "bold" }}>
                <Styles.TotalTableCell>{row.rowLabel}</Styles.TotalTableCell>
                <Styles.TotalTableCell>
                  {orderDataZustand.totals && orderDataZustand.totals.hasOwnProperty(row.rowInfo)
                    ? `R$ ${orderDataZustand.totals[row.rowInfo as keyof typeof orderDataZustand.totals]}`
                    : "R$ 0,00"}
                </Styles.TotalTableCell>
              </Styles.TotalTableRow>
            );
          } else if (row.rowStatus) {
            return (
              <Styles.TotalTableRow key={row.rowId}>
                <Styles.TotalTableCell>{row.rowLabel}</Styles.TotalTableCell>
                <Styles.TotalTableCell>
                  {orderDataZustand.totals && orderDataZustand.totals.hasOwnProperty(row.rowInfo)
                    ? `R$ ${orderDataZustand.totals[row.rowInfo as keyof typeof orderDataZustand.totals]}`
                    : "R$ 0,00"}
                </Styles.TotalTableCell>
              </Styles.TotalTableRow>
            );
          } else {
            return null;
          }
        })}
      </Styles.TotalTableBody>
    </Styles.TotalTable>
  );
};
